export type ThumbnailJobPhase =
  | "queued"
  | "downloading"
  | "extracting"
  | "uploading"
  | "done"
  | "error";

export type ThumbnailJob = {
  videoId: string;
  title: string;
  phase: ThumbnailJobPhase;
  loaded: number;
  total: number;
  error?: string;
};

const jobs = new Map<string, ThumbnailJob>();

export function isActiveThumbnailPhase(phase: ThumbnailJobPhase): boolean {
  return (
    phase === "queued" ||
    phase === "downloading" ||
    phase === "extracting" ||
    phase === "uploading"
  );
}

export function getThumbnailJob(videoId: string): ThumbnailJob | undefined {
  return jobs.get(videoId);
}

export function getThumbnailJobs(ids: string[]): ThumbnailJob[] {
  const out: ThumbnailJob[] = [];
  for (const id of ids) {
    const job = jobs.get(id);
    if (job) out.push(job);
  }
  return out;
}

export function upsertThumbnailJob(
  videoId: string,
  title: string,
): ThumbnailJob {
  const existing = jobs.get(videoId);
  if (existing && isActiveThumbnailPhase(existing.phase)) {
    return existing;
  }
  const job: ThumbnailJob = {
    videoId,
    title,
    phase: "queued",
    loaded: 0,
    total: 0,
  };
  jobs.set(videoId, job);
  return job;
}

export function patchThumbnailJob(
  videoId: string,
  patch: Partial<Omit<ThumbnailJob, "videoId">>,
): void {
  const existing = jobs.get(videoId);
  if (!existing) return;
  const next: ThumbnailJob = { ...existing, ...patch, videoId };
  if (patch.phase !== "error") {
    delete next.error;
  }
  jobs.set(videoId, next);
}
